var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-login"},[_c('router-link',{attrs:{"to":"/login"}},[_c('small',[_vm._v("Inicio de Sesión")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }